import React, {Component} from 'react'
import PropTypes from "prop-types";
import AlertConfirm from "../modals/Confirm";
import SvGraphics from "../../assets/SvGraphics";
import doctorApi from "../../services/ApiServices/doctorApi";

class RequestUpdateFileComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isUploadingFiles: false,
            Form_type_ID: this.props.Form_type_ID,
            entry: this.props.entry,
            FileUrl: null
        }
    }

    async componentDidMount() {
        let {entry, Form_type_ID, FileUrl} = this.state
        if (!FileUrl) {
            let fileToFind = {
                UserStorageID: entry.UserStorageID,
                RequestID: entry.RequestID,
                selectedCategory: Form_type_ID
            }
            let response = await doctorApi.getLeumitUploadedFile(fileToFind)
            if (response) {
                FileUrl = response.data.FileUrl
            }
        }
        this.setState({FileUrl})
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    saveSelectedFile = async (selectedFile) => {
        let {Form_type_ID, entry} = this.state
        this.setState({isUploadingFiles: true})
        let requestID = entry.RequestID ? parseInt(entry.RequestID) : 0
        let fileToAdd = {
            selectedCategory: Form_type_ID,
            file: selectedFile.files,
            UserStorageID: entry.UserStorageID,
            RequestID: requestID
        }

        let FileUrl
        let response = await doctorApi.getLeumitUploadedFile(fileToAdd)
        if (response) {
            FileUrl = response.data.FileUrl
            if(!FileUrl){
                await AlertConfirm({
                    options: {
                        cancelLabel: "none",
                        title: `Bad File Extension`,
                    }
                }, "PDF, PNG,JPEG, TIF,TXT, CSV, DOC")
            }
        }
        this.setState({isUploadingFiles: false, FileUrl: FileUrl})
    }

    deleteUploadedFile = async (Form_type_ID) => {
        let {entry, FileUrl} = this.state
        let {t} = this.props
        let confirm = await AlertConfirm({
            proceedLabel: t('patient_self_boarding.continue'),
            cancelLabel: t('patient_self_boarding.cancel'),
            options: {
                title: '',
            }
        }, t('patient_self_boarding.deleteConfirm'))
        if(confirm){
            this.setState({isUploadingFiles: true})

            let res = await doctorApi.deleteLeumitUploadedFiles(entry.UserStorageID, Form_type_ID,entry.RequestID)

            if (res) {
                FileUrl = null
            }
            this.setState({FileUrl, isUploadingFiles: false})
        }

    }

    render() {

        let Form_type_ID = this.props.Form_type_ID
        let Form_desc_he = this.props.Form_desc_he
        let FileUrl = this.state.FileUrl

        return (
            <div className={'patientsFormRow'}>
                <div className={'fileForms-label-Leumit'}>{Form_desc_he}</div>

                {!this.state.isUploadingFiles &&
                <input className={'chooseFileStyle-Leumit'} type="file" name="image_uploads" id="file-input-mandatory"
                       onChange={(event) => this.saveSelectedFile(event.target)}/>}
                {this.state.isUploadingFiles && <div className="loader-uploadfiles"/>}


                {FileUrl && <div style={{marginTop: '25px'}}>
                    <a href={FileUrl} target="_blank" className={'uploaded-files-label-view-Leumit'}>View uploaded
                        file</a>
                    <SvGraphics className={'uploaded-files-label-button-Leumit'}
                                onClick={() => this.deleteUploadedFile(Form_type_ID)} svgname={'delete-icon'}/>
                </div>}

            </div>

        )
    }
}

RequestUpdateFileComponent.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default RequestUpdateFileComponent;
